import {FC} from 'react';
import {t} from 'ttag';
import mailpointImage from '../assets/images/mailpoints.png';

const MailpointLeftPanel: FC = () => (
    <div className="mt-12 flex flex-1 flex-col items-center p-2">
        <img alt="" className="mb-2 w-52" src={mailpointImage} />
        <div className="mt-0 text-center">
            <h2 className="mx-0 mb-0">{t`MailPoints`}</h2>
            <p className="subheading">{t`MailPoints allow you to send documents via Japan Post. The rate is 1 MailPoint per 5 pages, maximum 200 pages per order.`}</p>
        </div>
    </div>
);

export default MailpointLeftPanel;
